import { useContext } from 'react';
import { MyGroupsContext } from '../context/MyGroupsContext';
import { UserSchoolYear } from '../../../api/school-year';

export type SchoolYear = {
  displayName: string;
  id: string;
} & UserSchoolYear;

export default function useGroups() {
  const { schoolYears, selectedSchoolYear, onSchoolYearChange, onGroupsChange, groupsWithSchool, isLoadingGroups } =
    useContext(MyGroupsContext);

  return {
    schoolYears,
    selectedSchoolYear,
    onSchoolYearChange,
    onGroupsChange,
    groupsWithSchool,
    isLoadingGroups,
  };
}
